import {padStart} from "lodash";

export default {

    methods: {

        padStart(item, totalLength = 5, padCharacter = '0') {
            return padStart(item, totalLength, padCharacter);
        },

    }

}
